import { Point, Matrix2D, Angle, NullChecker } from '@pacem/pacem-foundation';
// namespace Pacem.Geometry {
import { Utils } from './geom';
import * as LinearAlgebra from './linear-algebra';
function isPolygon(obj) {
    let vertices;
    return 'vertices' in obj && Array.isArray(obj.vertices)
        && (vertices = obj.vertices).length >= 3
        && vertices.every(i => Point.isPoint(i));
}
export class Polygon {
    static { this._eps = 1e-12; }
    static isPolygon(obj) {
        return isPolygon(obj);
    }
    static from(...points) {
        return { vertices: Array.from(points) };
    }
    static contains(polygon, p) {
        return Utils.inPolygon(p, polygon.vertices, 12);
    }
    static centroid(polygon) {
        const bbox = Polygon.boundingBox(polygon);
        return { x: bbox.x + bbox.width / 2, y: bbox.y + bbox.height / 2 };
    }
    static boundingBox(polygon) {
        return Utils.boundingBox(polygon.vertices);
    }
    static sides(polygon) {
        const { vertices } = polygon;
        const retval = [];
        for (let j = 1; j <= vertices.length; j++) {
            const v = vertices[j % vertices.length], v0 = vertices[j - 1];
            retval.push([v0, v]);
        }
        return retval;
    }
    static isConvex(polygon) {
        const { vertices } = polygon, l = vertices.length;
        if (l <= 3) {
            return true;
        }
        let sign = 0;
        for (let j = 0; j < vertices.length; j++) {
            const p0 = vertices[(j - 1 + l) % l], p = vertices[j], p1 = vertices[(j + 1) % l];
            const theta = Angle.angleBetween(p, p0, p1);
            //if (Math.abs(theta) > Math.PI) {
            //    return false;
            //}
            if (sign === 0) {
                sign = Math.sign(theta);
                continue;
            }
            if (sign != Math.sign(theta)) {
                return false;
            }
        }
        return true;
    }
    /**
     * Check whether a polygon is a self-intersecting one.
     * @param polygon
     * @returns
     */
    static isSelfIntersecting(polygon) {
        const { vertices } = polygon;
        if (vertices.length <= 3) {
            return false;
        }
        const sides = Polygon.sides(polygon);
        for (let side of sides) {
            for (let check of sides) {
                if ( /* same */check === side || /* contiguous */ check[0] === side[1] || side[0] === check[1]) {
                    continue;
                }
                const intersection = Utils.intersect(check, side);
                if (!NullChecker.isNull(intersection)) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * Returns whether the vertices of the spcified polygon have been provided in counter-clockwise order.
     * Meaningless in case of self-intersecting polygons.
     * @param polygon
     * @returns
     */
    static isCounterClockwise(polygon) {
        const { vertices: [p0, p1, p2] } = polygon;
        return Angle.angleBetween(p1, p0, p2) > 0; /* ccw angle <=> cw polygon and viceversa */
    }
    /**
     * Expands (or contracts) a polygon by a provided offset.
     * @param polygon
     * @param offset
     *
     */
    static expand(polygon, offset) {
        // TODO: https://en.wikipedia.org/wiki/Straight_skeleton
        const { vertices } = polygon, l = vertices.length, retval = [];
        for (let j = 0; j < vertices.length; j++) {
            const p0 = vertices[(j - 1 + l) % l], p = vertices[j], p1 = vertices[(j + 1) % l];
            const theta = Angle.angleBetween(p, p0, p1), scale = -offset / Math.sin(Math.abs(theta) / 2);
            const matrix = Matrix2D.scale(Matrix2D.identity, scale);
            const v0 = Point.subtract(p, p0);
            LinearAlgebra.Vector.normalize(v0);
            const v1 = Point.subtract(p, p1);
            LinearAlgebra.Vector.normalize(v1);
            const vector = Point.add(v0, v1);
            LinearAlgebra.Vector.normalize(vector);
            const pOffset = Matrix2D.multiply(vector, matrix);
            retval.push(Point.add(p, { x: pOffset.x.roundoff(), y: pOffset.y.roundoff() }));
        }
        return { vertices: retval };
    }
    /**
     * Returns the area of a polygon using the shoelace algorithm. It's meaningless in case of self-intersecting polygons.
     * @param polygon
     * @returns
     */
    static area(polygon) {
        return Utils.area(polygon.vertices);
    }
    static intersect(polygon1, polygon2) {
        return Utils.intersect(polygon1, polygon2);
    }
    /**
     * Returns the convex hull of a polygon.
     * @param polygon
     * @returns
     */
    static convexHull(polygon) {
        const vertices = Utils.convexHull(polygon.vertices);
        return { vertices };
    }
}
//}
